import { Text } from "@/ui/core";
import { Box, HStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface BulletItemProps extends ViewWithTestID {
  text: string;
}

const BulletItem = ({ testID, text }: Readonly<BulletItemProps>) => (
  <HStack gap={6}>
    <Text testID={joinTestIDs(testID, "dot")}>{"\u2022"}</Text>
    <Box flex={1} flexShrink={1}>
      <Text testID={joinTestIDs(testID, "text")}>{text}</Text>
    </Box>
  </HStack>
);
export type { BulletItemProps };
export default BulletItem;
